export default __webpack_public_path__ + "static/media/sensorx-sense.9d6218aa.png";